(() => {
  const bindCatalogSort = (root) => {
    root.querySelectorAll('[data-unifa-sort]').forEach((select) => {
      if (select.dataset.unifaBound === 'true') return;
      select.dataset.unifaBound = 'true';
      select.addEventListener('change', () => select.form?.requestSubmit());
    });
  };

  const bindGallery = (root) => {
    root.querySelectorAll('[data-unifa-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.unifaBound === 'true') return;
      gallery.dataset.unifaBound = 'true';

      const mainImage = gallery.querySelector('[data-unifa-gallery-main]');
      const dialog = gallery.querySelector('[data-unifa-gallery-dialog]');
      const dialogImage = dialog?.querySelector('[data-unifa-dialog-image]');

      gallery.querySelectorAll('[data-unifa-gallery-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!mainImage) return;
          mainImage.src = button.dataset.imageSrc;
          mainImage.srcset = button.dataset.imageSrcset || '';
          mainImage.alt = button.dataset.imageAlt || '';
          gallery.querySelectorAll('[data-unifa-gallery-thumb]').forEach((item) => item.setAttribute('aria-current', 'false'));
          button.setAttribute('aria-current', 'true');
        });
      });

      mainImage?.addEventListener('click', () => {
        if (!dialog || !dialogImage || typeof dialog.showModal !== 'function') return;
        dialogImage.src = mainImage.currentSrc || mainImage.src;
        dialogImage.alt = mainImage.alt;
        dialog.showModal();
      });

      dialog?.querySelector('[data-unifa-dialog-close]')?.addEventListener('click', () => dialog.close());
      dialog?.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  };

  const bindVariantSelectors = (root) => {
    root.querySelectorAll('[data-unifa-product-root]').forEach((productRoot) => {
      const select = productRoot.querySelector('[data-unifa-variant-select]');
      if (!select || select.dataset.unifaBound === 'true') return;
      select.dataset.unifaBound = 'true';

      const updateVariant = () => {
        const selected = select.options[select.selectedIndex];
        const sku = selected?.dataset.sku || '';
        const title = productRoot.dataset.productTitle || '';
        productRoot.querySelectorAll('[data-unifa-product-sku]').forEach((element) => {
          element.textContent = sku;
        });
        productRoot.querySelectorAll('[data-unifa-product-quote-link]').forEach((link) => {
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('product', title);
          if (sku) url.searchParams.set('sku', sku);
          else url.searchParams.delete('sku');
          link.href = `${url.pathname}${url.search}${url.hash}`;
        });
      };

      select.addEventListener('change', updateVariant);
      updateVariant();
    });
  };

  const init = (root = document) => {
    bindCatalogSort(root);
    bindGallery(root);
    bindVariantSelectors(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
